
   <micro-app-parceiros
   *ngIf="chamarWebcomponent"
    [ecommerce]="dadosCheckout"
    (carregamento)="carregamento()"
  ></micro-app-parceiros>

  <app-overlay *ngIf="env.overlay"></app-overlay>

 